/** Default internal domain for staff username → synthetic Auth email (must match Edge Function STAFF_INTERNAL_EMAIL_DOMAIN). */
export const DEFAULT_STAFF_AUTH_EMAIL_DOMAIN = 'staff.wiqaya.app';

export function staffAuthEmailDomain(): string {
  const d = import.meta.env.VITE_STAFF_LOGIN_EMAIL_DOMAIN as string | undefined;
  return (d && d.trim()) || DEFAULT_STAFF_AUTH_EMAIL_DOMAIN;
}

/** Normalize handle for use as the local part of a synthetic email (must match Edge Function rules). */
export function slugifyStaffLogin(raw: string): string {
  let s = raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, '.')
    .replace(/^\.+|\.+$/g, '')
    .replace(/\.{2,}/g, '.');
  if (s.length < 2) s = `u${s || 'x'}`.slice(0, 2);
  return s.slice(0, 48);
}

export function looksLikeEmail(identifier: string): boolean {
  const t = identifier.trim();
  if (!t.includes('@')) return false;
  const basic = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return basic.test(t);
}

/** Resolve what the user typed into the email string used by Supabase Auth `signInWithPassword`. */
export function resolveStaffAuthEmail(identifier: string, domain = staffAuthEmailDomain()): string {
  const t = identifier.trim().toLowerCase();
  if (looksLikeEmail(t)) return t;
  return `${slugifyStaffLogin(t)}@${domain}`.toLowerCase();
}
